export default __webpack_public_path__ + "static/media/36.85aed293.jpg";